import { c as _c } from "react/compiler-runtime";
import { IconButton, Typography, Stack, Tooltip } from '@mui/material';
export const SelectedItemsHeader = t0 => {
  const $ = _c(10);
  const {
    clearAll,
    title
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <Typography>{title}</Typography>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== clearAll) {
    t2 = event => {
      event.stopPropagation();
      clearAll();
    };
    $[2] = clearAll;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <i className="material-symbols-filter-alt-off-outline-rounded text-(--mui-palette-text-primary) h-[18px] w-[18px]" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <Tooltip title="Clear all"><IconButton onClick={t2}>{t3}</IconButton></Tooltip>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <Stack direction="row" alignItems="center" justifyContent="space-between" className="w-full">{t1}{t4}</Stack>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};